import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { RMSTextField } from '../../../shared/components/form-controls';
import CreateFormResolver from '../../../shared/utility/createFormResolver';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import { notify } from 'reducers/NotifierReducer';
import changePinSchema from '../../schema/changePinSchema';
import { changePin } from '../../services/userSignatureService';

const ChangePinDialog = ({ open, onClose, onSaved }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    resolver: CreateFormResolver(changePinSchema),
    mode: 'onSubmit',
    defaultValues: { pin: '', newPin: '' },
  });

  const handleSave = methods.handleSubmit(async (values) => {
    await executeApiAction({
      setLoading,
      dispatch,
      action: () => changePin(values),
      onSuccess: () => {
        dispatch(notify('PIN updated successfully', 'success'));
        onSaved?.();
        onClose();
      },
    });
  });

  return (
    <RMSCommonDialog
      open={open}
      title="Change PIN"
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      maxWidth="xs"
      fullWidth
      closeOnBackdropClick={false}
      dialogClassName="change-pin-dialog">
      <FormProvider {...methods}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <RMSTextField name="pin" label="Current PIN" type="password" autoComplete="off" />
          </Grid>
          <Grid item xs={12}>
            <RMSTextField name="newPin" label="New PIN" type="password" autoComplete="off" />
          </Grid>
        </Grid>
      </FormProvider>
    </RMSCommonDialog>
  );
};

export default ChangePinDialog;
